(() => {
  if (window.THBSupportV2) { window.THBSupportV2.init(document); return; }
  const normalize = (value) => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/\s+/g, ' ').trim();
  function initialize(root) {
    if (root.dataset.supportReady === 'true') return;
    const form = root.querySelector('[data-support-search]');
    const input = root.querySelector('[data-support-query]');
    const content = root.querySelector('[data-support-content]');
    const buttons = [...root.querySelectorAll('[data-support-category]')];
    const groups = [...content.querySelectorAll('.thb-faq-group')];
    const rows = [...content.querySelectorAll('.thb-faq-main details')].map((detail) => {
      const summary = detail.querySelector('summary');
      const title = normalize(summary?.textContent || '');
      const group = detail.closest('.thb-faq-group');
      const topic = normalize(group?.querySelector('h2')?.textContent || '');
      let category = 'orders';
      if (/return|refund|exchange|damag|faulty|incorrect/.test(title)) category = 'returns';
      else if (/product|care|stock|brand|material|authentic|dishwasher|gift|size|colour|color|made|handmade|everything available/.test(title)) category = 'products';
      else if (/deliver|shipping|ship |track|collect|pick.?up|arrive/.test(title)) category = 'delivery';
      else if (/order|payment|contact|visit/.test(title)) category = 'orders';
      else if (/return|refund/.test(topic)) category = 'returns';
      else if (/deliver|shipping|store/.test(topic)) category = 'delivery';
      else if (/product|care/.test(topic)) category = 'products';
      return { detail, group, category, search: normalize(detail.textContent), originalOpen: detail.open };
    });
    if (!rows.length || !form || !input || !groups.length) return;
    root.dataset.supportReady = 'true';
    let category = 'all';
    let searching = false;
    const status = root.querySelector('[data-support-status]');
    const empty = root.querySelector('[data-support-empty]');
    const clear = root.querySelector('[data-support-clear]');
    const countLabel = root.dataset.countLabel || '{count} answers';
    const countLabelOne = root.dataset.countLabelOne || '1 answer';
    const apply = () => {
      const query = normalize(input.value);
      const words = query.split(' ').filter(Boolean);
      if (query && !searching) rows.forEach((row) => { row.originalOpen = row.detail.open; });
      let visible = 0;
      rows.forEach((row) => {
        const match = (category === 'all' || row.category === category) && words.every((word) => row.search.includes(word));
        row.detail.hidden = !match;
        if (query && match) row.detail.open = true;
        else if (!query && searching) row.detail.open = row.originalOpen;
        if (match) visible++;
      });
      groups.forEach((group) => { group.hidden = !rows.some((row) => row.group === group && !row.detail.hidden); });
      buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.supportCategory === category)));
      empty.hidden = visible > 0;
      clear.hidden = !input.value;
      status.textContent = visible === 1 ? countLabelOne : countLabel.replace('{count}', String(visible));
      searching = Boolean(query);
    };
    const reset = (focus) => { input.value = ''; category = 'all'; apply(); if (focus) input.focus(); };
    form.addEventListener('submit', (event) => { event.preventDefault(); apply(); });
    form.addEventListener('reset', (event) => { event.preventDefault(); input.value = ''; apply(); input.focus(); });
    input.addEventListener('input', apply);
    input.addEventListener('keydown', (event) => { if (event.key === 'Escape' && input.value) { event.preventDefault(); input.value = ''; apply(); } });
    buttons.forEach((button) => button.addEventListener('click', () => { category = button.dataset.supportCategory; apply(); }));
    root.querySelector('[data-support-reset]').addEventListener('click', () => reset(true));
    const revealHash = () => {
      let id;
      try { id = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
      const target = id && document.getElementById(id);
      if (target && content.contains(target)) {
        reset(false);
        const detail = target.closest('details');
        if (detail) detail.open = true;
      }
    };
    const lifecycle = new AbortController();
    window.addEventListener('hashchange', revealHash, { signal: lifecycle.signal });
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(root)) lifecycle.abort();
    }, { signal: lifecycle.signal });
    form.hidden = false;
    root.querySelector('[data-support-tools]').hidden = false;
    apply();
    revealHash();
  }
  const init = (scope) => {
    if (scope.matches?.('[data-thb-support]')) initialize(scope);
    scope.querySelectorAll('[data-thb-support]').forEach(initialize);
  };
  window.THBSupportV2 = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
